// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"close-button_closeButton__vZlHS"};